import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaArrowLeft, FaMars, FaVenus, FaPaw, FaBirthdayCake } from "react-icons/fa";
import config from "../../../config";

export const PetDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [pet, setPet] = useState(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchPetDetails();
  }, []);

  const fetchPetDetails = async () => {
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/customer/getpet/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPet(res.data.pet);
    } catch {
      console.log("Failed to load pet details");
    }
  };

  if (!pet)
    return <p className="text-center mt-20 text-gray-500">Loading...</p>;

  return (
    <div className="p-6 md:p-10 font-[Inter]">
      
      {/* Back Button */}
      <button
        className="flex items-center gap-2 text-gray-700 mb-6 hover:text-black"
        onClick={() => navigate(-1)}
      >
        <FaArrowLeft /> Back
      </button>

      {/* Header */}
      <h1 className="text-3xl font-bold flex items-center gap-2 text-gray-800">
        <FaPaw className="text-[#FF7B00]" /> {pet.name}
      </h1>

      <p className="text-gray-500 text-lg mb-8 capitalize">
        {pet.pet_type_name} • {pet.breed_name}
      </p>

      {/* DETAILS GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        
        <DetailCard label="Gender" value={pet.gender} icon={
          pet.gender === "male" ? <FaMars className="text-blue-500" /> : <FaVenus className="text-pink-500" />
        }/>

        <DetailCard label="Age" value={pet.age || "-"} icon={<FaBirthdayCake className="text-[#FF7B00]" />} />

        <DetailCard label="Weight" value={pet.weight_kg ? `${pet.weight_kg} kg` : "-"} />
        
        <DetailCard label="Size" value={pet.size_label || "-"} />

        <DetailCard label="Vaccinated" value={pet.vaccinated ? "Yes" : "No"} />

        <DetailCard label="Aggression" value={pet.aggression || "-"} />

        <DetailCard label="Hair Type" value={pet.hair_type || "-"} />

        <DetailCard label="Hair Length" value={pet.hair_length || "-"} />

        <DetailCard
          label="Birthday"
          value={pet.birthday ? new Date(pet.birthday).toLocaleDateString() : "-"}
        />

      </div>
    </div>
  );
};

// Small reusable component
const DetailCard = ({ label, value, icon }) => (
  <div className="bg-gray-50 p-4 rounded-xl border">
    <p className="text-gray-500 text-sm">{label}</p>
    <div className="flex items-center gap-2 mt-1 font-semibold text-gray-800">
      {icon} {value}
    </div>
  </div>
);
